import {
  Box,
  FormControl,
  FormLabel,
  List,
  ListItem,
  Stack,
  Textarea,
  Typography,
} from '@mui/joy'
import { useTranslation } from 'react-i18next'
import {
  getCheckKindLabel,
  getYandexResultsDebts,
  getYandexResultsReports,
  isYandexEmptyResults,
} from '~/entities/common/DriverCheck/lib'
import { YandexResults as YandexResultsType } from '~/shared/api'
import { CheckKindEnum } from '~/shared/config/enums'
import { myPalette } from '~/shared/lib/theme'
import { Button } from '~/shared/ui/Buttons'

type YandexResultsProps = {
  results: YandexResultsType
  onClose: () => void
}

export function YandexResults({ results, onClose }: YandexResultsProps) {
  const { t } = useTranslation()

  if (isYandexEmptyResults(results)) {
    return <Typography>{t('alert.there are no data')}</Typography>
  }

  const reports = getYandexResultsReports(results)
  const isReports = Boolean(reports?.length)

  const debts = getYandexResultsDebts(results)
  const isDebts = Boolean(debts?.length)
  return (
    <Stack direction='column' spacing={2}>
      <Typography fontWeight={600} fontSize={20}>
        {t(getCheckKindLabel(CheckKindEnum.YANDEX))}
      </Typography>
      {isReports ? (
        <Stack spacing={3} py={1}>
          {reports.map(({ park, message }) => (
            <FormControl key={park}>
              <FormLabel>{park}</FormLabel>
              {message?.length ? (
                <Textarea value={message} readOnly />
              ) : (
                <Typography>{t('alert.no report data found')}</Typography>
              )}
            </FormControl>
          ))}
        </Stack>
      ) : (
        <Typography>{t('alert.no comments from taxi pages')}</Typography>
      )}
      <Box>
        {isDebts ? (
          <>
            <Typography fontWeight={600}>{t('debts')}</Typography>
            <List>
              {debts.map(({ park, boundsFrom, boundsTo }) => (
                <ListItem key={park + boundsFrom}>
                  <Typography>
                    {park}
                    {' — '}
                    <b>
                      {typeof boundsFrom === 'string'
                        ? t('less than')
                        : t('more than')}{' '}
                      {(boundsFrom ?? boundsTo ?? '').replace('-', '')}
                    </b>
                  </Typography>
                </ListItem>
              ))}
            </List>
          </>
        ) : (
          <Typography sx={{ color: myPalette.green['600'] }}>
            {t('no debts')}
          </Typography>
        )}
      </Box>

      <br />
      <Button variant='gray' onClick={onClose}>
        {t('button.close')}
      </Button>
    </Stack>
  )
}
